module.exports = __webpack_public_path__ + "img/actlog.c69d2742.svg";